<template>
    <v-navigation-drawer
        v-model="drawer"          
        width="600"
        app
        temporary
        right
        class="wost-drawer"
    >
        <div class="form-head">
            {{ titleForm }}
        </div>
        <div class="wrapper-form-crud overflow-y-auto">               
            <v-form>
                <v-card class="padding-bootom-0">
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col :cols="12" class="space-inter-inputs">
                                    <v-autocomplete
                                    label="Categoría"
                                    :items="categories"
                                    v-model="supplyForm.category_id">
                                    </v-autocomplete>
                                </v-col>                                
                            </v-row>
                            <v-row>
                                <v-col :cols="12" class="space-inter-inputs">
                                    <v-autocomplete
                                    label="Unidad de medida"
                                    :items="units"
                                    v-model="supplyForm.unit_id">
                                    </v-autocomplete>
                                </v-col>                                
                            </v-row>
                            <v-row>
                                <v-col :cols="12" class="space-inter-inputs">
                                    <v-text-field v-model="supplyForm.name" label="Descripción"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col :cols="12" class="space-inter-inputs">
                                    <v-text-field v-model="supplyForm.cost" label="Costo" type="number"></v-text-field>
                                </v-col>                                    
                            </v-row>                                                       
                        </v-container>
                    </v-card-text>

                </v-card>
                <br>
                <v-divider></v-divider>
                <br>
                <div class="text-a-right">
                    <v-btn color="error" outlined @click="closeForm()" class="wost-btn-new">Cancelar</v-btn>
                    &nbsp;
                    <v-btn v-if="actionCrud === 'create'" color="primary" raised @click="addSupply()" class="wost-btn-new">Guardar</v-btn>
                    <v-btn v-else color="primary" raised @click="modifySupply()" class="wost-btn-new">Actualizar</v-btn>
                </div>                
            </v-form>
        </div>
    </v-navigation-drawer>
</template>

<script>

import { mapActions, mapMutations, mapState } from 'vuex';

import {APIService} from '@/APIService';
const apiService = new APIService();

export default {
    name: 'CreateOrUpdate',
    computed: {
        ...mapState('supplies', [
            'supplies',
            'supply',
            'supplyId'
        ]),
    },
    data() {
        return {
            titleForm: '',
            drawer: false,
            actionCrud: '',
            supplyForm: {
                id: null,
                category_id: null,
                unit_id: null,
                name: null,
                cost: null,
                stock: null,
                minimum_stock: null
            },
            categories: [],
            units: []
        }
    },
    methods: {
        ...mapActions('supplies', [
            'getSupplies',
            'createSupply',
            'updateSupply'
        ]),
        ...mapMutations('supplies', [
            'setSupply',
            'setSupplyId'
        ]),
        showForm(title, action) {
            this.clearform()
            this.titleForm = title
            this.actionCrud = action
            if (this.actionCrud === 'update') {
                this.setSupplyId(this.supply.id)
                this.setSupplyForm(this.supply)
            }
            this.drawer = !this.drawer
        },
        clearform() {
            this.supplyForm.id = null
            this.supplyForm.category_id = null
            this.supplyForm.unit_id = null
            this.supplyForm.name = null
            this.supplyForm.cost = null
            this.supplyForm.stock = null
            this.supplyForm.minimum_stock = null
        },
        setSupplyForm(supply) {
            this.supplyForm.id = supply.id
            this.supplyForm.category_id = supply.category_id
            this.supplyForm.unit_id = supply.unit_id
            this.supplyForm.name = supply.name
            this.supplyForm.cost = supply.cost
            this.supplyForm.stock = supply.stock
            this.supplyForm.minimum_stock = supply.minimum_stock
        },
        closeForm() {
            this.drawer = false
        },
        addSupply() {
            this.setSupply(this.supplyForm)
            this.createSupply()
            this.closeForm()
        },
        modifySupply() {
             this.setSupply(null)
             this.setSupply(this.supplyForm)
             this.updateSupply()
             this.closeForm()
        }
    },
    mounted() {
        apiService.getCategoriesDropdown().then((response) => {
            this.categories = response.data   
        });
        apiService.getUnitsDropdown().then((response) => {
            this.units = response.data;            
        });
    }
}
</script>

<style scoped>

</style>